'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.IteratorContext = void 0;
var _react = require('react');
var IteratorContext = /*#__PURE__*/ (0, _react.createContext)({
});
exports.IteratorContext = IteratorContext;
IteratorContext.displayName = 'IteratorContext';
